import { Component, ChangeDetectionStrategy, inject, effect, signal, CUSTOM_ELEMENTS_SCHEMA, NgZone } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomRouteService } from '../../services/custom-route.service';
import { WelcomePlannerViewService } from './services';
import { AllReadyComponent, WelcomePlannerContentComponent } from "./components";

@Component({
  selector: 'app-welcome-planner-view',
  standalone: true,
  imports: [
    TranslateModule,
    AllReadyComponent,
    WelcomePlannerContentComponent
],
  templateUrl: './welcome-planner-view.component.html',
  styleUrls: ['./welcome-planner-view.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomePlannerViewComponent {
  // Services
  private _customRouteService = inject(CustomRouteService);
  private _ngZone = inject(NgZone); // change detection control (setTimeout)
  private _welcomePlannerViewService = inject(WelcomePlannerViewService);
  
  // Services signals
  protected isWelcomeViewShown = this._customRouteService.isWelcomeViewShown;
  protected isAllReadyViewShown = this._welcomePlannerViewService.isAllReadyViewShown;

  // Local properties
  private _timeoutId: number | null = null;
  
  // Effects
  hideAllReadyView = effect(() => {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
    }
    
    this._ngZone.runOutsideAngular(() => {
      this._timeoutId = window.setTimeout(() => {
        this._ngZone.run(() => {
          this._welcomePlannerViewService.setIsAllReadyViewShown(false);
        });
      }, 3000);
    });
  }, { allowSignalWrites: true }); 
  
  // Lifecycle hooks
  ngOnDestroy(): void {
    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
      this._timeoutId = null;
    }
  }
}
